import { ThemeProvider } from "@mui/material";
import { PropsWithChildren } from "react";
import { useDynamicTheme } from "@hooks/use-dynamic-theme";

/**
 * Theme provider that dynamically switches between light and dark mode
 * based on the isDarkModeEnabled state
 */
export function DynamicThemeProvider({
  children,
}: PropsWithChildren): JSX.Element {
  const theme = useDynamicTheme();

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
